var map = {
	"./icon_bar.svg": 1219,
	"./icon_craftsman.svg": 1220,
	"./icon_culinary.svg": 1221,
	"./icon_entrepreneur.svg": 1222,
	"./icon_management.svg": 1223,
	"./icon_service.svg": 1224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1218;